import { render, staticRenderFns } from "./MailingStatusBadge.vue?vue&type=template&id=67fa7af0&"
import script from "./MailingStatusBadge.vue?vue&type=script&lang=js&"
export * from "./MailingStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports